import type { InsertConsequenceMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertConsequenceDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { InsertConsequenceInput } from './types';

export const useInsertConsequence = createMutationHook({
  name: 'insertConsequence',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.consequence.insert.mutationOptions({ onSuccess }),
  mapInput: (variables: InsertConsequenceInput): InsertConsequenceInput => ({
    ParentIssueId: variables.ParentIssueId ?? '',
    Title: variables.Title ?? '',
    Description: variables.Description,
    Criticality: variables.Criticality,
    CostType: variables.CostType,
    CostValue: variables.CostValue ?? 0,
    Type: variables.Type,
    CustomAttributeData: variables.CustomAttributeData ?? null,
  }),
  invalidate: (trpc) => [
    trpc.frontend.consequence.register.queryKey(),
    trpc.frontend.consequence.consequenceById.queryKey(),
    trpc.frontend.consequence.getByParentIssueId.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.consequence.consequenceCount.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertConsequenceMutation => ({
    insert_consequence_one: {
      __typename: 'consequence',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertConsequenceDocument,
  graphqlVariables: (variables: InsertConsequenceInput) => ({
    ...variables,
  }),
  evictFields: ['consequence', 'consequence_aggregate'],
});
